import { asyncRoutes, constantRoutes } from '@/router'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}
/**
 * 通过后端返回的权限菜单表进行过滤
 * 
 */
export function createNewArray(arr, selectionRouter, pathKey = 'path', childrenKey = 'children') {
  // 递归函数以处理任意深度的子路径
  function findAndCloneMatchingItems(targetItems, sourceItems) {
    return targetItems.map(targetItem => {
      const matchedItem = sourceItems.find(item => item[pathKey] === targetItem[pathKey]);

      if (matchedItem) {
        // 如果目标项有子元素，进行子路径匹配
        if (targetItem[childrenKey] && targetItem[childrenKey].length > 0 && matchedItem[childrenKey]) {
          matchedItem[childrenKey] = findAndCloneMatchingItems(targetItem[childrenKey], matchedItem[childrenKey]);
        }

        return matchedItem;
      }

      return null;
    }).filter(item => item !== null);
  }

  const arrNew = [];
  for (const item of arr) {
    const matchedRouter = selectionRouter.find(router => router[pathKey] === item[pathKey]);
    if (matchedRouter) {
      arrNew.push(findAndCloneMatchingItems([item], [matchedRouter])[0]);
    }
  }

  return arrNew;
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  // generateRoutes({ commit }, roles) {
  generateRoutes({ commit }, menus) {
    return new Promise(resolve => {
      // if (roles.includes('admin')) {
      //   accessedRoutes = asyncRoutes || []
      // } else {
        // accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
       let accessedRoutes = createNewArray(menus,asyncRoutes)
      // }
      // 添加404
      accessedRoutes = [...accessedRoutes,{ path: '*', redirect: '/404', hidden: true }]
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
